export default {
  MediumUserName: "Sabesan96",
  DevToUserName: "thesabesan",
  TwitterUserName: "TheSabesan",
};
